(function () {
  class SettingTotalBet extends PIXI.Container {
    constructor(json) {
      super();

      this._json = json;

      this.stakeController = undefined;
      this.stakeText = undefined;

      this.platformEnabled = false;
      this.platformVisible = false;

      this._promotionOn = false;
    }

    //////////////////////////////////////////////////
    initialise() {
      messageBus.subscribe("spinner:GameConfigEvent", this.init.bind(this));
      messageBus.subscribe(
        "stake:stakeChanged",
        this.onStakeChanged.bind(this)
      );
      messageBus.subscribe(
        "common:PromotionStarted",
        this.onPromotionStarted.bind(this)
      );
      messageBus.subscribe(
        "common:PromotionEnded",
        this.onPromotionEnded.bind(this)
      );
    }

    ////////////////////////////////////////////////////////
    init(configEvent) {
      const promotionActive = configEvent.data.slotConfig.promotionActive;
      if (promotionActive !== null && promotionActive !== undefined) {
        this._promotionOn = promotionActive;
      }

      // platform enabled?
      this.platformEnabled = configEvent.data.uiElements.btnUpstake.enabled;
      this.platformVisible = configEvent.data.uiElements.btnUpstake.visible;

      this.stakePreviousButton = resourceManager.get(this._json.minusButtonId);
      this.stakePreviousButton.onPressedCallback =
        this.onStakePreviousPressed.bind(this);

      this.stakeNextButton = resourceManager.get(this._json.plusButtonId);
      this.stakeNextButton.onPressedCallback =
        this.onStakeNextPressed.bind(this);

      this.stakeText = resourceManager.get(this._json.stakeTextId);

      // golden bet buttons
      this.goldenBetButtonOn = resourceManager.get(
        this._json.goldenBetButtonOnId
      );
      this.goldenBetButtonOn.mousedown = this.goldenBetButtonOn.touchstart =
        this.goldenBetOnPressed.bind(this);

      this.goldenBetButtonOff = resourceManager.get(
        this._json.goldenBetButtonOffId
      );
      this.goldenBetButtonOff.mousedown = this.goldenBetButtonOff.touchstart =
        this.goldenBetOffPressed.bind(this);

      this.goldenBetButtonOn.interactive = false && this.platformEnabled;
      this.goldenBetButtonOff.interactive = true && this.platformEnabled;

      this.goldenBetButtonOn.visible = false && this.platformVisible;
      this.goldenBetButtonOff.visible = true && this.platformVisible;

      this.stakeController = resourceManager.getController("stakeController");

      this.updateButtons();
    }

    ////////////////////////////////////////////////////////
    onStakeNextPressed() {
      // soundManager.play("hbc_UI_increase_v1");
      this.stakeController.selectNextStake();
      this.updateButtons();
    }

    ////////////////////////////////////////////////////////
    onStakePreviousPressed() {
      // soundManager.play("hbc_UI_increase_v1");
      this.stakeController.selectPreviousStake();
      this.updateButtons();
    }

    ////////////////////////////////////////////////////////
    goldenBetOnPressed() {
      this.goldenBetButtonOn.interactive = false;
      this.goldenBetButtonOff.interactive = true;

      this.goldenBetButtonOn.visible = false;
      this.goldenBetButtonOff.visible = true;

      let goldenBetButton = resourceManager.get("goldenBetToggleButton");
      goldenBetButton.onPressedCallback();

      this.stakeText.setText(
        gdk.formatCurrency(this.stakeController.CurrentStake)
      );
    }

    ////////////////////////////////////////////////////////
    goldenBetOffPressed() {
      this.goldenBetButtonOn.interactive = true;
      this.goldenBetButtonOff.interactive = false;

      this.goldenBetButtonOn.visible = true;
      this.goldenBetButtonOff.visible = false;

      let goldenBetButton = resourceManager.get("goldenBetToggleButton");
      goldenBetButton.onPressedCallback();

      this.stakeText.setText(
        gdk.formatCurrency(this.stakeController.CurrentStake)
      );
    }

    ////////////////////////////////////////////////////////
    updateButtons() {
      // update the stake buttons
      this.stakePreviousButton.enableButton(
        this.stakeController.SelectedStakeIndex > 0 && !this._promotionOn
      );
      this.stakeNextButton.enableButton(
        this.stakeController.SelectedStakeIndex <
          this.stakeController.Stakes.length - 1 && !this._promotionOn
      );

      this.stakeText.setText(
        gdk.formatCurrency(this.stakeController.CurrentStake)
      );
    }

    onStakeChanged() {
      if (this.stakeText !== undefined) {
        this.updateButtons();
      }
    }

    onPromotionStarted = function () {
      this._promotionOn = true;
      this.updateButtons();
    };

    onPromotionEnded() {
      this._promotionOn = false;
      this.updateButtons();
    }
  }

  //////////////////////////////////////////////////
  create = function (json) {
    return new SettingTotalBet(json);
  };

  //////////////////////////////////////////////////
  initialise = function (json, container, resources) {
    container.initialise();
  };

  //////////////////////////////////////////////////
  getFilesRequired = function (json) {
    return ["", ""];
  };

  resourceManager.registerObjectType(
    "settingTotalBet",
    create,
    initialise,
    getFilesRequired
  );
})();
